import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {RedirectComponent} from '../shared/components/redirect/redirect.component';

const appCoreRoutes: Routes = [
  {path: '', component: RedirectComponent}
];

@NgModule({
  imports: [RouterModule.forChild(appCoreRoutes)],
  exports: [RouterModule]
})
export class CoreRoutingModule {
}

